import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslationPipe } from '../appUtilities/translation.pipe';
import { GlobalLanguageSwitcherComponent } from '../includes/global-language-switcher/global-language-switcher.component';

@NgModule({
  declarations: [TranslationPipe, GlobalLanguageSwitcherComponent],
  imports: [CommonModule, IonicModule],
  exports: [TranslationPipe, GlobalLanguageSwitcherComponent],
})
export class SharedModule {}
